import { createSlice } from '@reduxjs/toolkit';
import { IProfile } from './../api/profile.api';
import { RootState } from './store';

const initialState: IProfile = {
  id: -1,
  name: '',
  email: '',
  phone: '',
  image: '',
  phone_number: '',
  phone_code: '',
  email_verified_at: '',
  time_zone_id: '',
  industry: {
    id: -1,
    name: '',
    code: '',
  },
  status: 1,
  country: {
    id: -1,
    name: '',
    code_alpha_2: '',
    code_alpha_3: '',
    currency_code: '',
    currency_symbol: '',
    phone_code: -1,
  },
  role: {
    id: -1,
    name: '',
    role_value: -1,
  },
  permissions: {
    data: [],
  },
  tenants: {
    data: [],
  },
  integration: {},
  zoho_crm_url: '',
  domain: 'jadwalh.com',
  client_system_Steps: {
    create_first_event: false,
    create_first_client: false,
    integrate_with_calendar: false,
    integrate_with_crm: false,
    integrate_with_gmail: false,
    // create_first_workflow: false,
  },
  is_payment_active: false,
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfile: (state, action) => {
      return action.payload;
    },
    setZohoCrmUrl: (state, action) => {
      state.zoho_crm_url = action.payload;
    },
    reset: () => initialState,
  },
});

export const { setProfile, setZohoCrmUrl, reset } = profileSlice.actions;

export const getProfileData = (state: RootState) => state.profile;
export const getPermissions = (state: RootState) => state.profile.permissions;
export const getZohoCrmUrl = (state: RootState) => state.profile.zoho_crm_url;
export const getTenants = (state: RootState) => state.profile.tenants;
export const getRole = (state: RootState) => state.profile.role;

export default profileSlice.reducer;
